var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Course flex box_1200"},[_c('PersonMenu',{ref:"childRef",on:{"getData":_vm.getData}}),_c('PortraitOne',{attrs:{"type":"course","pageTotal":_vm.pageTotal,"listData":_vm.listData},on:{"getPageSize":_vm.getPageSize,"getPageIndex":_vm.getPageIndex,"change":_vm.handleChangeSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }